const theme = {
  colors: {
    primary: "#0078D4", // Hauptfarbe (z. B. Blau)
    secondary: "#FF6E40", // Akzentfarbe (z. B. Orange)
    //background: "#121212", // Hintergrundfarbe
    text: "#ffffff", // Textfarbe
    cardBackground:"rgba(3,3,3,0.8)",
    cardShadow: "rgba(0, 0, 0, 0.1)",
    cardHoverShadow: "rgba(0, 0, 0, 0.2)",
    //background: '#121212',
    accent: 'rgba(255, 79, 0, 1)', // Akzentfarbe für Schaltflächen
    textPrimary: '#ffffff',
  },
  fonts: {
    primary: "Arial, sans-serif",
  },
  spacing: {
    small: "10px",
    medium: "20px",
    large: "30px",
  },
};

export default theme;